const {
  REACT_APP_BASE_URL,
  REACT_APP_GOOGLE_MAP_KEY,
  REACT_APP_MAP_CENTER_LAT,
  REACT_APP_MAP_CENTER_LNG,
  REACT_APP_MAP_ZOOM_LEVEL,
  REACT_APP_SC_EDITOR_GROUP_ANGLE_X,
  REACT_APP_SC_EDITOR_GROUP_ANGLE_Y,
  REACT_APP_SC_EDITOR_ANGLE_X_MAX,
  REACT_APP_SC_EDITOR_ANGLE_X_MIN,
  REACT_APP_SC_EDITOR_ANGLE_Y_MAX,
  REACT_APP_SC_EDITOR_ANGLE_Y_MIN,
  REACT_APP_SC_EDITOR_ZOOM,
  REACT_APP_SC_EDITOR_ZOOM_MAX,
  REACT_APP_SC_EDITOR_ZOOM_MIN,
  REACT_APP_SC_EDITOR_ZOOM_STEP,
  REACT_APP_SC_EDITOR_SCALE_ANGLE,
  REACT_APP_SC_EDITOR_SCALE_ZOOM,
} = process.env;

const API_URL = `${REACT_APP_BASE_URL}/api/`;

export default {
  API_URL,
  API_ACCOUNT: `${API_URL}account/`,
  API_LOGIN: `${API_URL}account/login/`,
  API_REGISTER: `${API_URL}account/register/`,
  API_RESET_PASSWORD: `${API_URL}account/reset_password/`,
  API_SET_PASSWORD: `${API_URL}account/set_password/`,
  API_PROJECT: `${API_URL}project/`,
  API_PROJECT_REFERENCE: projectId => `${API_URL}project/${projectId}/reference/`,
  // FRS 4.2.3 (4.2) - Emission Factor + Carbon
  API_EMISSION_FACTOR: `${API_URL}emission_factor/`,
  API_EMISSION_FACTOR_ACTIVE: `${API_URL}emission_factor/active/`,
  API_EMISSION_FACTOR_HISTORY: id => `${API_URL}emission_factor/${id}/history/`,
  API_CARBON_KPI: `${API_URL}project_carbon/carbon-kpi/`,
  API_PROJECT_CARBON_SUMMARY: projectId => `${API_URL}project_carbon/${projectId}/carbon-summary/`,
  API_PROJECT_IMG: `${API_URL}project_image/`,
  API_PROJECT_AC_CENTRAL: `${API_URL}rel/project/ac_central/`,
  API_PROJECT_AC_CENTRAL_GROUPS: projectId => `${API_URL}project/${projectId}/ac_central_groups/`,
  API_PROJECT_BIND_AC_CENTRAL: projectId => `${API_URL}project/${projectId}/bind_ac_central/`,
  API_PROJECT_UNBIND_AC_CENTRAL_GROUP: projectId => `${API_URL}project/${projectId}/ac_central_group`,
  API_PROJECT_BOILER: `${API_URL}rel/project/hw_boiler/`,
  API_PROJECT_HEAT_PUMP: `${API_URL}rel/project/hw_heat_pump/`,
  API_PROJECT_SOLAR_ENERGY: `${API_URL}rel/project/re_photovoltaic/`,
  API_PROJECT_HEAT_TO_ELECTRICAL_ENERGY: `${API_URL}rel/project/re_heat_to_electrical/`,
  API_PROJECT_OTHER_RENEWABLE_ENERGY: `${API_URL}rel/project/re_other_renewable_energy/`,
  API_BUILDING: `${API_URL}building/`,
  API_FLOOR: `${API_URL}floor/`,
  API_ENVELOP: `${API_URL}envelop/`,
  API_ENVELOP_WALL: `${API_URL}envelop_wall/`,
  API_ENVELOP_ROOF: `${API_URL}envelop_roof/`,
  API_ZONE: `${API_URL}zone/`,
  API_ZONE_AHU: `${API_URL}rel/zone/ac_fan_coil/`,
  API_ZONE_AC_PACKAGED_UNIT: `${API_URL}rel/zone/ac_packaged/`,
  API_ZONE_AC_SPLIT_TYPE: `${API_URL}rel/zone/ac_split/`,
  API_ZONE_LT_SET: `${API_URL}rel/zone/lt_lighting_set/`,
  API_ZONE_OTHER_EQUIPMENT: `${API_URL}rel/zone/oe_equipment/`,
  API_SECTION: `${API_URL}section/`,
  API_SECTION_COMPONENT: `${API_URL}rel/section/component/`,
  API_MATERIAL: `${API_URL}material/`,
  API_MATERIAL_TRANSPARENT: `${API_URL}material_transparent/`,
  API_MATERIAL_OPAQUE: `${API_URL}material_opaque/`,
  API_COMPONENT_TRANSPARENT: `${API_URL}component_transparent/`,
  API_COMPONENT_OPAQUE: `${API_URL}component_opaque/`,
  API_REL_COMPONENT_MATERIAL: `${API_URL}rel/component/material/`,
  API_COMPONENT: `${API_URL}component/`,
  API_AC_SPLIT_TYPE: `${API_URL}ac_split/`,
  API_AC_PACKAGED_UNIT: `${API_URL}ac_packaged/`,
  API_AC_PACKAGED_SUB: `${API_URL}ac_packaged_sub/`,
  API_AC_PACKAGED_PACKAGED_SUB: `${API_URL}rel/ac_packaged/ac_packaged_sub/`,
  API_AC_CENTRAL: `${API_URL}ac_central/`,
  API_AC_CENTRAL_CHILLER: `${API_URL}rel/ac_central/ac_chiller/`,
  API_AC_CENTRAL_WATER_PUMP: `${API_URL}rel/ac_central/ac_water_pump/`,
  API_AC_CENTRAL_COOLING_TOWER: `${API_URL}rel/ac_central/ac_cooling_tower/`,
  API_AC_CENTRAL_AIR_HANDLING_UNIT: `${API_URL}rel/ac_central/ac_fan_coil/`,
  API_CHILLER: `${API_URL}ac_chiller/`,
  API_WATER_PUMP: `${API_URL}ac_water_pump/`,
  API_COOLING_TOWER: `${API_URL}ac_cooling_tower/`,
  API_AIR_HANDLING_UNIT: `${API_URL}ac_fan_coil/`,
  API_BOILER: `${API_URL}hw_boiler/`,
  API_REF_BOILER_TYPE: `${API_URL}ref_type_boiler/`,
  API_HEAT_PUMP: `${API_URL}hw_heat_pump/`,
  API_REF_HEAT_PUMP_TYPE: `${API_URL}ref_type_heat_pump/`,
  API_SOLAR_ENERGY: `${API_URL}re_photovoltaic/`,
  API_OTHER_RENEWABLE_ENERGY: `${API_URL}re_other_renewable_energy/`,
  API_HEAT_TO_ELECTRICAL_ENERGY: `${API_URL}re_heat_to_electrical/`,
  API_OTHER_EQUIPMENT: `${API_URL}oe_equipment/`,
  API_BULB: `${API_URL}ls_bulb/`,
  API_BALLAST: `${API_URL}ls_ballast/`,
  API_LIGHTING_SET: `${API_URL}ls_lighting_set/`,
  API_LIGHTING_SET_LUMINAIRE: `${API_URL}rel/ls_lighting_set/ls_bulb/`,
  API_LIGHTING_SET_BALLAST: `${API_URL}rel/ls_lighting_set/ls_ballast/`,
  API_PROVINCE: `${API_URL}ref_province/`,
  API_BUILDING_TYPE: `${API_URL}ref_building/`,
  API_REF_HEAT_DISSIPATION: `${API_URL}ref_heat_dissipation/`,
  API_REF_SOLAR_ABSORPTANCE: `${API_URL}ref_solar_absorptance/`,
  API_REF_EVALUATION_PURPOSE: `${API_URL}evaluation_purpose/`,
  API_REF_AC_BRAND: `${API_URL}ref_brand_ac/`,
  API_REF_LUMINAIRE_BRAND: `${API_URL}ref_brand_lighting/`,
  API_REF_LUMINAIRE_TYPE: `${API_URL}ref_type_bulb/`,
  API_REF_BALLAST_BRAND: `${API_URL}ref_brand_lighting/`,
  API_REF_BALLAST_TYPE: `${API_URL}ref_type_ballast/`,
  API_PROJECT_INSPECTION: `${API_URL}project_submission/`,
  API_SUBMISSION_ATTACHMENT: `${API_URL}submission_attachment/`,
  API_SUBMISSION_COMMENT: `${API_URL}submission_comment/`,
  API_PROJECT_INVITATION: `${API_URL}invitation/`,
  API_PROJECT_MEMBERS: `${API_URL}project_members/`,
  API_NOTIFICATION: `${API_URL}notification/notification/`,
  API_PROJECT_STATS: `${API_URL}project/stats/`,
  API_PROJECT_STAT_OTTV: `${API_URL}project/stat/ottv/`,
  API_PROJECT_STAT_RTTV: `${API_URL}project/stat/rttv/`,
  API_PROJECT_STAT_LPD: `${API_URL}project/stat/lpd/`,
  API_PROJECT_STAT_COP: `${API_URL}project/stat/cop/`,
  API_PROJECT_STAT_SEER: `${API_URL}project/stat/seer/`,
  API_PROJECT_STAT_BOILER: `${API_URL}project/stat/boiler_efficiency/`,
  API_PROJECT_STAT_HOT_WATER_COP: `${API_URL}project/stat/hot_water_cop/`,
  API_PROJECT_STAT_PVE: `${API_URL}project/stat/renewable_pve/`,
  API_PROJECT_STAT_HEE: `${API_URL}project/stat/renewable_hee/`,
  API_PROJECT_STAT_OTHER_RE: `${API_URL}project/stat/renewable_other/`,
  API_PROJECT_STAT_LIGHTING_POWER: `${API_URL}project/stat/lighting_power/`,
  API_PROJECT_STAT_REPORT: `${API_URL}project/stat/report/export/`,
  API_PROJECT_EXPORT: `${API_URL}project/export/`,
  API_PROJECT_STATS_SAVING_SUMMARY: `${API_URL}project/stats/saving_summary/`,
  MAP_KEY: REACT_APP_GOOGLE_MAP_KEY || '',
  MAP_CENTER_LAT: parseFloat(REACT_APP_MAP_CENTER_LAT || '0'),
  MAP_CENTER_LNG: parseFloat(REACT_APP_MAP_CENTER_LNG || '0'),
  MAP_ZOOM_LEVEL: parseInt(REACT_APP_MAP_ZOOM_LEVEL || '1'),
  DATA_TABLE_PAGE_SIZE: 10,
  DEBOUNCE_TIME: 250,
  MAPPER: {
    outer_surface_colors: {
      '0.3': 'reflective and white surface',
      '0.5': 'surface of pale color',
      '0.7': 'surface of slightly dark color',
      '0.9': 'surface of dark color',
    },
  },
  SC_EDITOR_GROUP_ANGLE_X: parseInt(REACT_APP_SC_EDITOR_GROUP_ANGLE_X, 10),
  SC_EDITOR_GROUP_ANGLE_Y: parseInt(REACT_APP_SC_EDITOR_GROUP_ANGLE_Y, 10),
  SC_EDITOR_ANGLE_X_MAX: parseInt(REACT_APP_SC_EDITOR_ANGLE_X_MAX, 10),
  SC_EDITOR_ANGLE_X_MIN: parseInt(REACT_APP_SC_EDITOR_ANGLE_X_MIN, 10),
  SC_EDITOR_ANGLE_Y_MAX: parseInt(REACT_APP_SC_EDITOR_ANGLE_Y_MAX, 10),
  SC_EDITOR_ANGLE_Y_MIN: parseInt(REACT_APP_SC_EDITOR_ANGLE_Y_MIN, 10),
  SC_EDITOR_ZOOM: parseInt(REACT_APP_SC_EDITOR_ZOOM, 10),
  SC_EDITOR_ZOOM_MAX: parseFloat(REACT_APP_SC_EDITOR_ZOOM_MAX),
  SC_EDITOR_ZOOM_MIN: parseInt(REACT_APP_SC_EDITOR_ZOOM_MIN, 10),
  SC_EDITOR_ZOOM_STEP: parseFloat(REACT_APP_SC_EDITOR_ZOOM_STEP, 10),
  SC_EDITOR_SCALE_ANGLE: parseFloat(REACT_APP_SC_EDITOR_SCALE_ANGLE),
  SC_EDITOR_SCALE_ZOOM: parseFloat(REACT_APP_SC_EDITOR_SCALE_ZOOM),
  PROJECT_SUBMISSION: {
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    APPROVED: 'approved',
    REJECTED: 'rejected',
  },
  ROLES: {
    INSPECTOR: 'inspector',
    AUDITOR: 'auditor',
  },
};



// WEBPACK FOOTER //
// ./src/config/constants.js